import React, { useState } from "react";

const inputStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "0.95rem",
  boxSizing: "border-box",
};

const Contact = () => {
const [form, setForm] = useState({
  issueType: "General Enquiry",
  referenceId: "",
  message: "",
});

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  setLoading(true);
  setSuccess(false);
  setError("");

  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/api/support/contact`,
      {
        method: "POST",
      headers: {
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
},
        body: JSON.stringify(form),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "Something went wrong");
    }

    setSuccess(true);

    // clear form
   setForm({
  issueType: "General Enquiry",
  referenceId: "",
  message: "",
});

  } catch (err) {
    setError(err.message || "Failed to send message");
  }

  setLoading(false);
};

  return (
    <div
      style={{
        padding: "60px 20px",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "800",
          marginBottom: "15px",
          textAlign: "center",
        }}
      >
        Contact Us
      </h1>

      <p
        style={{
          textAlign: "center",
          marginBottom: "35px",
          color: "#555",
          fontSize: "1.05rem",
        }}
      >
        Need help with your account, listing, payment or swap? Send us a
        message below.
      </p>

      <div
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "14px",
          border: "1px solid #e6e6e6",
          boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
    

          <select
            name="issueType"
            value={form.issueType}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="General Enquiry">General Enquiry</option>
            <option value="Listing Issue">Listing Issue</option>
            <option value="Payment Issue">Payment Issue</option>
            <option value="Swap Issue">Swap Issue</option>
            <option value="Account Issue">Account Issue</option>
            <option value="Verification Issue">Verification Issue</option>
            <option value="Technical Issue">Technical Issue</option>
            <option value="Other">Other</option>
          </select>

          <input
            type="text"
            name="referenceId"
            placeholder="Listing ID or Deal ID (optional)"
            value={form.referenceId}
            onChange={handleChange}
            style={inputStyle}
          />

          <textarea
            name="message"
            placeholder="Your Message"
            rows="6"
            value={form.message}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "12px",
              backgroundColor: "#2e7d32",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>

          {success && (
            <p style={{ color: "#2e7d32", marginTop: "10px" }}>
              Your message has been sent successfully.
            </p>
          )}

          {error && (
            <p style={{ color: "red", marginTop: "10px" }}>
              {error}
            </p>
          )}
        </form>
      </div>

      <div
        style={{
          marginTop: "30px",
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#f1faf3",
          borderRadius: "14px",
        }}
      >
    <p style={{ marginBottom: "8px" }}>
  Prefer email?
</p>

<p style={{ fontWeight: "600", marginBottom: "4px" }}>
  Client Exchange Pty Ltd
</p>

<p style={{ marginBottom: "8px", color: "#555", fontSize: "0.95rem" }}>
  ABN 23 692 732 157
</p>

<p style={{ fontWeight: "600" }}>
  support@clientexchange.com.au
</p>
      </div>
    </div>
  );
};

export default Contact;